module.exports = __webpack_public_path__ + "img/template-management.8b766783.png";